<c-container class="pt-3">

  <c-row class="mb-3">
    <c-col class="col-lg-12">
      <app-range-filter [title]="screenTitle" [model]="rangeSelector"
        (modelChange)="handleRouteFilterChange($event)"></app-range-filter>
    </c-col>
  </c-row>

  <c-row>
    <c-col class="col-lg-9">
      <c-card>
        <c-card-header class="card-header">
          <h4 class="card-header__heading">
        {{screenTitle}} Average Score</h4>
        </c-card-header>
        <c-card-body>
          <c-chart
            [data]="networkUtilisationData"
            [options]="networkUtilizationChartOptions"
            type="line"
            height="500"
          />
        </c-card-body>
      </c-card>
    </c-col>
    <c-col class="col-lg-3">
      <c-row class="mb-2">
        <c-col class="col-lg-12">
          <c-card>
            <c-card-header class="card-header">
              <h4 class="card-header__heading">
                Unused Reasons</h4>
            </c-card-header>
            <c-card-body>
              <c-chart [data]="vehicleStatusData" type="doughnut" height="228" />
            </c-card-body>
          </c-card>
        </c-col>
      </c-row>
      <c-row>
        <c-col class="col-lg-12">
          <c-card>
            <c-card-header class="card-header">
              <h4 class="card-header__heading">
                Utilisation Breakdown</h4>
            </c-card-header>
            <c-card-body>
              <c-chart [data]="vehicleUtilizationData" type="doughnut" height="228" />
            </c-card-body>
          </c-card>
        </c-col>
      </c-row>
    </c-col>
  </c-row>

  <c-row>
    <c-col class="mt-3 mb-3">

      <c-card class="h-100">
        <c-card-header class="card-header">
            <h4 class="card-header__heading">
              Depot League Table (Region {{regionName}})</h4>
        </c-card-header>
        <c-card-body class="card-body">
          <c-smart-table #smartTable="cSmartTable" [columns]="leagueDepotColumns" [columnFilter]="true" [columnSorter]="true" [itemsPerPage]="5" [items]="leagueDepotData"
            [tableProps]="{ hover: true, striped: true, responsive: true }" activePage="1" header pagination >

            <ng-template
            cTemplateId="tableData"
            let-columnName="columnName"
            let-item="item"
            let-tdContent="tdContent"
            >
              <td>
                @switch (columnName) {
                  @case('depot_name') {
                    <a class="link" (click)="gotoDepot(item)">{{tdContent}}</a>
                  }
                  @case ('total_snapshot_count_in_range') {
                    {{item['total_utilized_count_in_range'] ? (item['total_utilized_count_in_range'] / item['total_snapshot_count_in_range'] * 100).toFixed(2) : 0}}%
                  }
                  @case ('total_today_snapshot_count') {
                    {{item['today_utilized_count'] ? (item['today_utilized_count'] / item['total_today_snapshot_count'] * 100).toFixed(2) : 0}}%
                  }

                  @default {
                    {{ tdContent ? tdContent : '-'}}
                  }
                }
              </td>
            </ng-template>
          </c-smart-table>

        </c-card-body>
      </c-card>

    </c-col>
    <c-col class="mt-3 mb-3">
      <c-card class="h-100">
        <c-card-header class="card-header">
          <h4 class="card-header__heading">
            Region League Table</h4>
        </c-card-header>
        <c-card-body class="card-body">
          <c-smart-table #smartTable="cSmartTable" [columns]="leagueRegionColumns" [columnFilter]="true" [columnSorter]="true" [itemsPerPage]="5" [items]="leagueRegionData"
            [tableProps]="{ hover: true, striped: true, responsive: true }" activePage="1" header pagination>
            <ng-template
              cTemplateId="tableData"
              let-columnName="columnName"
              let-item="item"
              let-tdContent="tdContent"
            >
              <td>
                @switch (columnName) {
                  @case('region') {
                    <a [routerLink]="'/department/' + departmentId + '/region/' + tdContent.region_id">{{ tdContent.region_name }}</a>
                  }
                  @case ('total_snapshot_count_in_range') {
                    {{item['total_utilized_count_in_range'] ? (item['total_utilized_count_in_range'] / item['total_snapshot_count_in_range'] * 100).toFixed(2) : 0}}%
                  }
                  @case ('total_today_snapshot_count') {
                    {{item['today_utilized_count'] ? (item['today_utilized_count'] / item['total_today_snapshot_count'] * 100).toFixed(2) : 0}}%
                  }

                  @default {
                    {{ tdContent ? tdContent : '-'}}
                  }
                }
              </td>
            </ng-template>
          </c-smart-table>
        </c-card-body>
      </c-card>
    </c-col>
  </c-row>
  <c-row class="mt-3">
    <c-col>
      <!-- Top Unused Vehicle Count by Day -->
      <c-card class="h-100">
        <c-card-header class="card-header">
          <h4 class="card-header__heading">
            Top Unused Depot by Day (Unused Vehicle at Depot)</h4>
        </c-card-header>
        <c-card-body class="card-body">

          <c-smart-table #smartTable="cSmartTable" [columns]="unutilisedByDayColumns" [columnFilter]="true" [columnSorter]="true" [itemsPerPage]="5" [items]="unutilisedVehiclesData"
            [tableProps]="{ hover: true, striped: true, responsive: true }" activePage="1" header pagination>
            <ng-template
              cTemplateId="tableData"
              let-columnName="columnName"
              let-item="item"
              let-tdContent="tdContent"
            >
              <td>
                @switch (columnName) {
                  @case ('snapshot_date') {
                    {{tdContent ? (tdContent | date: 'dd-MM-yyyy') : '-' }}

                  }
                  @default {
                    {{ tdContent ? tdContent : '-'}}
                  }
                }
              </td>
            </ng-template>
          </c-smart-table>
        </c-card-body>
        <c-card-footer>
          <a cCardLink routerLink='/daily-vehicle-count'>View all by day</a>
        </c-card-footer>
      </c-card>

    </c-col>
    <c-col>
      <!-- Most Frequent Unused Vehicles -->
      <c-card class="card h-100">
        <c-card-header class="card-header">
          <h4 class="card-header__heading">Most frequent Unused vehicles</h4>
        </c-card-header>

        <c-card-body class="card-body">
          <c-smart-table [columns]="frequentUnutilisedColumns" [columnFilter]="true" [columnSorter]="true" [itemsPerPage]="5"
            [items]="mostFrequentlyUsedVehicles" [tableProps]="{ hover: true, striped: true, responsive: true }"
            activePage="1" header pagination />
        </c-card-body>
      </c-card>
    </c-col>
  </c-row>

</c-container>
<c-toaster placement="top-end" class="p-3" position="fixed">
  <c-toast
    (timer)="onToasterTimerChange($event)"
    (visibleChange)="onToasterVisibleChange($event)"
    [visible]="visible()"
  >
    <c-toast-header>
     Cannot View Depot
    </c-toast-header>
    <c-toast-body>
      <p>This depot is not assigned to your user.</p>
      <c-progress thin [value]="percentage()" />
    </c-toast-body>
  </c-toast>
</c-toaster>